document.addEventListener('DOMContentLoaded', () => {
  const elements = document.querySelectorAll('.footer .links .icon-tooltip')

  const checkToShow = (elm) => {
    if (elm.classList.contains('icon-tooltip--open')) {
      elm.classList.remove('icon-tooltip--open')
    } else {
      elm.classList.add('icon-tooltip--open')
    }
  }

  elements.forEach((elm) => {
    elm.parentElement.addEventListener('click', (event) => {
      event.preventDefault()
      checkToShow(elm)
    })
    elm.parentElement.addEventListener('blur', () => {
      checkToShow(elm)
    })
  })
})
